<template>
  <generic-form
    v-slot="{ data }"
    :endpoints="endpoints"
    targetClass="md-size-100"
    creationEnabled
  >
    <md-table v-bind:value="data" v-fixedTableHeader>
      <md-table-row
        slot="md-table-row"
        slot-scope="{ item, index }"
        v-wavyDeletable="index"
      >
        <md-table-cell md-label="Name">
          <backend-text
            v-model="item.name"
            labelClass="no-asterisk"
            rules="required"
          ></backend-text>
        </md-table-cell>
        <md-table-cell md-label="Start">
          <ValidationProvider rules="required" v-slot="{ passed, failed }">
            <md-datepicker
              :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
              v-model="item.travel_date_from"
              :mdModelType="String"
              mdImmediately
            >
              <slide-y-down-transition>
                <md-icon class="error" v-show="failed">close</md-icon>
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon class="success" v-show="passed">done</md-icon>
              </slide-y-down-transition>
            </md-datepicker>
          </ValidationProvider>
        </md-table-cell>
        <md-table-cell md-label="End">
          <ValidationProvider rules="required" v-slot="{ passed, failed }">
            <md-datepicker
              :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
              v-model="item.travel_date_to"
              :mdModelType="String"
              mdImmediately
            >
              <slide-y-down-transition>
                <md-icon class="error" v-show="failed">close</md-icon>
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon class="success" v-show="passed">done</md-icon>
              </slide-y-down-transition>
            </md-datepicker>
          </ValidationProvider>
        </md-table-cell>
      </md-table-row>
    </md-table>
  </generic-form>
</template>

<script>
import Api from "../../../../openapi/src/api/YearSeasonApi.js";

import BackendText from "../../Components/Inputs/BackendText.vue";
import GenericForm from "../GenericForm.vue";

import { SlideYDownTransition } from "vue2-transitions";
import { extend } from "vee-validate";
import { required } from "vee-validate/dist/rules";

extend("required", required);

export default {
  components: {
    GenericForm,
    BackendText
  },
  data() {
    const api = new Api();
    const vm = this;

    return {
      endpoints: {
        get: api.getYearSeasons.bind(api, vm.$root.hotelId),
        update: api.updateYearSeasons.bind(api),
        delete: api.deleteYearSeason.bind(api)
      }
    };
  },
  methods: {}
};
</script>
